<template>
  <div :class="['si-section-title', { light }]">
    <h2 v-viewportChanged="showView" class="hidden-element">{{ title }}</h2>
    <p v-if="subtitle" v-viewportChanged="showView" class="hidden-element">{{ subtitle }}</p>
    <p v-if="subdesc" class="sub-desc hidden-element" v-viewportChanged="showView">{{ subdesc }}</p>
  </div>
</template>

<script>
export default {
  name: 'SISectionTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    subdesc: {
      type: String,
      default: '',
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.si-section-title {
  margin-bottom: 36px;
  text-align: center;

  h2 {
    margin: 0;
    font-size: 30px;
    line-height: 42px;
    color: #212121;
  }

  p {
    margin: 6px 0 0;
    font-size: 16px;
    line-height: 24px;
    color: #74787a;
  }

  .sub-desc {
    color: #222;
  }

  &.light {
    h2 {
      color: #ffffff;
    }

    p {
      color: #a7aeb1;
    }
  }
}

@media only screen and (max-width: 768px) {
  .si-section-title {
    margin-bottom: 24px;

    h2 {
      font-size: 24px;
      line-height: 34px;
    }
  }
}
</style>
